import React from 'react';
import { Column } from 'vetrf-ui/dist/utils/type/table/Column';

export const getColumns = (): Column[] => [
  {
    dataFormatter: (item) => item.name,
    key: 'name',
    title: 'Наименование',
    width: '45%',
  },
  {
    dataFormatter: (item) => item.language?.name,
    key: 'regNumber',
    title: 'Язык',
    width: '15%',
  },
  {
    dataFormatter: (item) => {
      const { file } = item;
      if (file?.id) {
        return <a href={`/files/${file.id}`}>{file.name}</a>;
      }
    },
    key: 'file',
    title: 'Файл',
  },
];
